import { observer } from "mobx-react"
import { PeriodSlider } from "modules/common/components/period/PeriodSlider"
import { SessionType } from "modules/session/auth/models/session"
import { DepartmentBlockMode, WorkloadStoreType } from "modules/spending/workload/models/workload-store"
import React from "react"
import { DepartmentBlock } from "./DepartmentBlock"
import styles from "./WorkloadPage.module.scss"

import { getSnapshot } from "mobx-state-tree"
import { Search } from "modules/common/components/form/Search"
import { Loader, LocalLoader } from "modules/common/components/loader/Loader"
import { CollapseExpandAll } from "modules/common/components/table/CollapseExpandAll"
import { NoData } from "modules/common/components/table/NoData"
import { Zoomer } from "modules/common/components/zoomer/Zoomer"
import { SORTABLE_DATE_FORMAT } from "modules/common/constants"
import { menuItems } from "modules/root/components/menu/MainMenu"
import { can, canAny } from "modules/session/auth/access"
import { WorkDays } from "modules/spending/components/WorkDays"
import func from "modules/spending/functionalities"
import { ScheduleStoreType } from "modules/spending/schedule/models/schedule-store"
import moment from "moment"
import { WorkloadDayType } from "../models/workload-day"
import { ContextMenu } from "./ContextMenu"
import { WorkloadOrderList } from "./WorkloadOrderList"

const menu = menuItems()

class Page extends React.Component<WorkloadPlanPageProps, WorkloadPlanPageState> {
  printable = React.createRef<any>();
  private day: any | null = null;
  constructor(props: any) {
    super(props)

    this.state = {
      mode: "day",
      selectedCell: "",
      copyItem: {},
      monthModeIsEditing: false,
      selectedCells: [],
      showContext: false,
      x: 0,
      y: 0,
    }
  }

  componentDidMount() {
    document.title = menu.spending.nested.workload.label

    const { store } = this.props
    store.load()
  }

  isInPast = (day: string) => {
    const inputDate = moment(day, SORTABLE_DATE_FORMAT)
    const today = moment().startOf("day") // Начало сегодняшнего дня

    return inputDate.isBefore(today)
  };

  render() {
    const { session, store, setUserFilter } = this.props
    const { year, month, workDaysCount, monthsWorkHours, orders, tasks, departmentMap, isLoading, isLoadingFull } =
      store
    const { selectedCell, selectedCells, mode, monthModeIsEditing } = this.state

    const canManage = canAny([func.WORKLOAD_EDIT, func.WORKLOAD_EDIT_ALL], session.access)
    const canDepartmentOnly = can(func.WORKLOAD_EDIT, session.access) && !can(func.WORKLOAD_EDIT_ALL, session.access)

    // const canExport = can(func.WORKLOAD_EDIT, session.access);
    const showContext = (x: number, y: number, day: WorkloadDayType) => {
      this.day = day
      this.setState({ x, y, showContext: true })
    }
    const transform = store.transform


    return (
      <div
        className={styles.page}
        ref={this.printable}
        onClick={(e) => {
          this.setState({ showContext: false })
        }}
      >
        <LocalLoader active={isLoading} />
        <Loader active={isLoadingFull} />

        {this.state.showContext && (
          <ContextMenu
            xpos={`${this.state.x / 2}px`}
            ypos={`${this.state.y}px`}
            onCopy={() => {
              const model = {
                day: this.day.day,
                employerId: this.day.user.id,
                comment: this.day.comment,
                units: this.day.units.map((unit: any) => {
                  return {
                    comment: unit.comment,
                    hours: unit.hours,
                    inventoryNumber: unit.order ? unit.order.inventoryNumber : null,
                    workId: unit.task ? unit.task.workId : null,
                    type: unit.type,
                    fromHome: unit.type === "Работа из дома" ? true : false,
                    isWorkedOut: unit.isWorkedOut,
                    task: unit.task,
                    guid: unit.task ? unit.task.guid : null,
                  }
                }),
              }

              this.setState({ copyItem: model, showContext: false })
            }}
            onPaste={
              !this.isInPast(this.day)
                ? () => {
                  this.setState({ showContext: false })
                  let item = this.state.copyItem
                  if (item.units) {
                    item.day = this.day.day
                    item.employerId = this.day.user.id
                    this.saveDay(item, false)
                  }
                }
                : undefined
            }
            onClear={!this.isInPast(this.day) ? this.removeDay : undefined}
          />
        )}
        <div className={styles.filters}>
          <div className={styles.periodSlider}>
            <div className={styles.projects}>
              {store.users.length > 0 && (
                <WorkloadOrderList
                  orders={store.workloadOrders}
                  canDepartmentOnly={canDepartmentOnly}
                  saveDefaultDepartmentSpending={store.saveDefaultDepartmentSpending}
                  departments={Object.keys(departmentMap).map((department) => department)}
                />
              )}
            </div>
            <div>
              <PeriodSlider year={year} month={month} onChange={this.gotoMonth} />
              <div className={styles.center}>
                <WorkDays days={workDaysCount} hours={monthsWorkHours} users={store.users.length} />
              </div>
            </div>
            <div className={styles.actions}>
              <div className={styles.right}>
                {!monthModeIsEditing && (
                  <>
                    {/* {canExport && (
                            <>
                                <PlanrButton
                                    type="graybtn"
                                    icon="general-export"
                                    onClick={this.export}
                                    round={true}
                                    title={texts.export}
                                />
                                <PlanrButton
                                    type="graybtn"
                                    icon="general-print"
                                    onClick={this.print}
                                    round={true}
                                    title={texts.print}
                                />
                            </>
                        )} */}

                    <Search query={store.query} onSearch={setUserFilter} />
                  </>
                )}
              </div>
              <Zoomer zoom={store.zoom} min={50} max={100} step={5} onChange={store.setZoom} />
              <CollapseExpandAll onChange={store.collapser.setAll} />
            </div>
          </div>

          <div className={styles.tools}>
            {/* <div className={styles.left}>
              <div className={styles.infoButton}>
                <Popover
                  usePortal={true}
                  interactionKind={"click"}
                  content={
                    <div className={styles.infoPopup}>
                      <p>Зажатием ЛКМ можно выделять ячейки в строке как слева направо, так и справа налево.</p>
                      <hr />
                      <p>Чтобы скопировать данные из ячейки, щелкните по ней ПКМ и выберите команду Копировать.</p>
                      <hr />
                      <p>Чтобы вставить данные в выбранные ячейки, щелкните по ним ПКМ и выберите команду Вставить.</p>
                      <hr />
                      <p>
                        Чтобы изменить данные в выбранных ячейках вручную, дважды щелкните по одной из них ЛКМ. Если
                        ячейка
                        <br /> не была пуста, вы можете применить ее данные к остальным ячейкам, нажатием кнопки
                        Сохранить.
                      </p>
                    </div>
                  }
                >
                  <GeneralIcon type="general-exclamation" style={{ color: "#EA561E", cursor: "pointer" }} size={22} />
                </Popover>
              </div>
            </div> */}
          </div>
        </div>

        <div className={styles.zoomArea} >
          <div style={{
            transform: `scale(${transform})`,
            transformOrigin: 'top left',
            width: 'fit-content',
            minWidth: '100%'
          }}>
            {Object.keys(departmentMap).map((department) => {
              const users = departmentMap[department]

              return (
                <DepartmentBlock
                  mode={mode}
                  cellMode={"projects"}
                  department={department}
                  users={users}
                  orders={orders}
                  tasks={tasks}
                  selectedCell={selectedCell}
                  onSelectCell={this.selectCell}
                  onSelectCells={this.selectCells}
                  key={department}
                  selectedCells={selectedCells}
                  onSave={this.saveDay}
                  store={store}
                  canManage={canManage}
                  userLogin={session.userLogin}
                  collapsed={!store.collapser.opened.get(department)}
                  toggleCollapse={store.collapser.toggle}
                  onContext={showContext}
                  removeDay={this.removeDay}
                  changeComment={(model: any) => {
                    store.setComment(model)
                  }}
                />
              )
            })}</div>
        </div>

        {store.isEmpty && !isLoading && <NoData className={styles.nodata} />}
      </div>
    )
  }

  gotoMonth = (year: number, month: number) => {
    this.props.store.load(year, month)
    this.props.schedule.setPeriod(year, month)
  };

  selectCell = (selectedCell: string, day?: any) => {
    this.setState({ selectedCell: selectedCell })
    this.day = day
  };

  selectCells = (selectedCells: string[]) => {
    this.setState({ selectedCells })
  };
  removeDay = () => {
    this.setState({ showContext: false })
    const model = {
      day: this.day.day,
      employerId: this.day.user.id,
      comment: this.day.comment,
      units: this.day.units.map((unit: any) => {
        return {
          comment: unit.comment,
          hours: unit.hours,
          inventoryNumber: unit.order ? unit.order.inventoryNumber : null,
          workId: unit.task ? unit.task.workId : null,
          type: unit.type,
          fromHome: unit.type === "Работа из дома" ? true : false,
          isWorkedOut: unit.isWorkedOut,
          task: unit.task,
          guid: unit.task ? unit.task.guid : null,
        }
      }),
    }

    this.saveDay(model, true)
  };
  saveDay = async (model: any, isRemove: boolean = false) => {
    const index = this.state.selectedCells.findIndex((cell) => cell.slice(0, 10) === model.day)
    let success: any = false

    let arr: any = []
    let oldarr: any = []
    if (!isRemove) {
      if (index !== -1 && this.state.selectedCells.length > 1) {
        this.state.selectedCells.forEach((cell) => {
          let userDay: any = {}

          this.props.store.users.forEach((user) => {
            if (user.user?.id === model.employerId) {
              user.days.forEach((day) => {
                if (cell.slice(0, 10) === day.day) {
                  const mod = {
                    day: day.day,
                    employerId: day.user.id,
                    comment: day.comment,
                    units: day.units.map((unit: any) => {
                      return {
                        comment: unit.comment,
                        hours: unit.hours,
                        inventoryNumber: unit.order ? unit.order.inventoryNumber : null,
                        workId: unit.task ? unit.task.workId : null,
                        type: unit.type,
                        fromHome: unit.type === "Работа из дома" ? true : false,
                        isWorkedOut: unit.isWorkedOut,
                        task: unit.task,
                        guid: unit.task ? unit.task.guid : null,
                      }
                    }),
                  }
                  userDay = mod
                }
              })
            }
          })
          const item = {
            day: cell.slice(0, 10),
            employerId: model.employerId,
            units: model.units,
            comment: model.comment,
          }
          arr.push(item)

          if (userDay) {
            const itemOld = {
              day: userDay.day,
              employerId: userDay.employerId,
              units: userDay.units,
              comment: userDay.comment,
              isRemove: isRemove,
            }
            oldarr.push(itemOld)
          }
        })

        success = await this.props.store.saveArrayOfCells(arr, oldarr)
      } else {
        let arr: any = []
        let oldarr: any = []
        const item = {
          day: model.day,
          employerId: model.employerId,
          units: model.units,
          comment: model.comment,
          isRemove: isRemove,
        }
        arr.push(item)
        if (this.day && this.day.units.length > 0) {
          const daySnapshot = getSnapshot<WorkloadDayType>(this.day)
          const oldItem = {
            day: daySnapshot.day,
            employerId: daySnapshot.user.id,
            comment: this.day.comment,
            units: this.day.units.map((unit: any) => {
              return {
                comment: unit.comment,
                hours: unit.hours,
                inventoryNumber: unit.order ? unit.order.inventoryNumber : null,
                workId: unit.task ? unit.task.workId : null,
                type: unit.type,
                fromHome: unit.type === "Работа из дома" ? true : false,
                isWorkedOut: unit.isWorkedOut,
                tasks: unit.tasks,
              }
            }),
          }
          oldarr.push(oldItem)
        }
        success = await this.props.store.saveArrayOfCells(arr, oldarr)
      }
    } else {
      if (index !== -1 && this.state.selectedCells.length > 1) {
        this.state.selectedCells.forEach((cell) => {
          let userDay: any = {}

          this.props.store.users.forEach((user) => {
            if (user.user?.id === model.employerId) {
              user.days.forEach((day) => {
                if (cell.slice(0, 10) === day.day) {
                  const mod = {
                    day: day.day,
                    employerId: day.user.id,
                    comment: day.comment,
                    units: day.units.map((unit: any) => {
                      return {
                        comment: unit.comment,
                        hours: unit.hours,
                        inventoryNumber: unit.order ? unit.order.inventoryNumber : null,
                        workId: unit.task ? unit.task.workId : null,
                        type: unit.type,
                        fromHome: unit.type === "Работа из дома" ? true : false,
                        isWorkedOut: unit.isWorkedOut,
                        tasks: unit.tasks,
                      }
                    }),
                  }
                  userDay = mod
                }
              })
            }
          })
          if (userDay) {
            const item = {
              day: userDay.day,
              employerId: userDay.employerId,
              units: userDay.units,
              comment: userDay.comment,
              isRemove: isRemove,
            }
            arr.push(item)
          }
        })

        success = await this.props.store.saveArrayOfCells(arr)
      } else {
        const item = {
          day: model.day,
          employerId: model.employerId,
          units: model.units,
          comment: model.comment,
          isRemove: isRemove,
        }
        arr.push(item)
        success = await this.props.store.saveArrayOfCells(arr)
      }
    }
    if (success) {
      // Сбрасываем выбранные ячейки после успешного сохранения
      this.setState({ selectedCells: [], selectedCell: "" })
    }
    return success
  };

  // print = () => this.props.store.print(this.state.mode);

  // export = () => this.props.store.export(this.state.mode);

  setMonthModeEditingState = (state: boolean) => this.setState({ monthModeIsEditing: state });
}

export const WorkloadPage = observer(Page)

interface WorkloadPlanPageProps {
  store: WorkloadStoreType
  schedule: ScheduleStoreType
  session: SessionType
  setUserFilter: (value: string) => void
}

interface WorkloadPlanPageState {
  selectedCell: string
  mode: DepartmentBlockMode
  monthModeIsEditing: boolean
  selectedCells: string[]
  copyItem: any
  showContext: boolean
  x: number
  y: number
}
